import { render } from "./DemoProgressBar.vue?vue&type=template&id=a8fdcf46"
import script from "./DemoProgressBar.vue?vue&type=script&lang=js"
export * from "./DemoProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__